import { ProductBuilderState } from '../state'

export const productBuilderLoadingBegin = (state: ProductBuilderState): ProductBuilderState => ({
    ...state,
    loading: true,
    loadingCounter: state.loadingCounter + 1
})

export const productBuilderLoadingEnd = (state: ProductBuilderState): ProductBuilderState => ({
    ...state,
    loading: state.loadingCounter > 1,
    loadingCounter: state.loadingCounter - 1
})